module.exports = __webpack_public_path__ + "static/media/sms.f09da7eb.svg";